
import { BaseDto } from './base.dto';
import { CharityDto } from './charity.dto';
import { MerchantDto } from './merchant.dto';

export class MerchantCharityDto extends BaseDto {
  startDate?: Date;
  endDate?: Date;
  minimumAmount?: number;
  fixedAmount?: number;
  visibleGiftCard?: boolean;
  description?: string;
  charityId?: number;

  charity?: CharityDto;
  merchant?: MerchantDto;
  
}
